import { ref } from "vue";
import { defineStore } from "pinia";
import api_config from "@/Configs/api_config";
import Axios from "axios-observable";
import { useLanguageStore } from "./languageStore";

export const useAppartmentStore = defineStore("appartment", () => {
  const storeName = ref("Resido");
  const propertyData = ref([]);
  const settings = ref({});
  const showLoader = ref(false);
  const filters = ref({});
  const languageStore = useLanguageStore();

  // Fetch settings data
  const getSettings = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_website_settings`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  // Fetch area data
  const getAreas = (page = 1, page_size = 8, all_aries = false) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_all_areas`,
      data: { page, page_size, all_aries },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  // Fetch cities data
  const getAllCities = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_all_cities`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getAllProjects = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_all_projects`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getProjectList = (page = 1, page_size = 8) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_project_list`,
      data: { page, page_size },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getAboutUs = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_about_Us`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getUnitTyes = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_unit_types`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getCategories = () => {
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_categories`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  // Fetch blog data
  const getBlogs = (page, page_size) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_blogs`,
      data: { page, page_size },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  // Fetch property info
  const getProperties = (page, page_size, filters, order_by) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_properties`,
      data: { page, page_size, filters, order_by },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const imageFormat = (url) => {
    const formatedUrl = url?.includes("/files/")
      ? `${api_config.base_url}${url}`
      : url;
    return encodeURI(formatedUrl);
  };

  const createContact = (contactData) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.contact_api.create_contact`,
      data: contactData,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getBlogByName = (blogName) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_blog_by_name`,
      data: { blog_name: blogName },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getProjectByName = (projectName) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_project_by_name`,
      data: { project_name: projectName },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getPropertyByName = (propertyName) => {
    return Axios.request({
      method: "post",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.get_property_by_name`,
      data: { property_name: propertyName },
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getContactInfo = () => {
    showLoader.value = true;
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.contact_info`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const getQuestions = () => {
    showLoader.value = true;
    return Axios.request({
      method: "get",
      url: `${api_config.base_url}/api/method/appartement.appartement.home_api.getQuestions`,
      headers: {
        Accept: "application/json",
        "X-Frappe-CSRF-Token": window.csrf_token,
      },
    });
  };

  const priceFormat = (price) => {
    const locale = languageStore.currentLanguage === "ar" ? "ar-SA" : "en-SA";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "SAR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms * 1000));
  }

  return {
    storeName,
    propertyData,
    settings,
    filters,
    getSettings,
    getAreas,
    getBlogs,
    getContactInfo,
    getProperties,
    createContact,
    getAllCities,
    getUnitTyes,
    getBlogByName,
    getPropertyByName,
    getProjectByName,
    getCategories,
    getAllProjects,
    getQuestions,
    priceFormat,
    imageFormat,
    getAboutUs,
    getProjectList,
    delay,
  };
});
